import { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Pagination,
  Dropdown,
  Form,
  Tab,
  Tabs,
} from 'react-bootstrap';
import Footer from 'Components/Footer';
import NavbarTop from 'Components/Navbar';
import { useHistory ,useParams , Link} from 'react-router-dom';
import TabIconAssets from 'MiddleSystems/Components/layout/TabIconProperty';
import TabsIcon from 'MiddleSystems/Components/layout/TabsIcon';
import MenuProperty from 'MiddleSystems/Components/layout/MenuProperty';
import Back from 'assets/icon/back.png';
import Staff from 'assets/icon/staff.png';
import PropertyImage from 'assets/icon/asset.png'
import Branch_manage from 'assets/icon/branch-manage.png';
import Write from 'assets/icon/flat-style-circle-write.png';
import Note from 'assets/icon/address_book.png';
import View from 'assets/icon/view-member.png';
import Property from '../Components/Property/Property';
import ViewAll from '../Components/Property/ViewAll';
import Data from './Components/Data';
import Storage from './Components/Storage';

//api
import { LoadProperty } from 'actions/property/index'
import { useDispatch } from 'react-redux';

export default function DataProperty(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id }= useParams();

  const [DataProperty,setData] = useState({
    Name: null,
    Unit: null,
    selectedImage: null,
    displayImage: null,
    Note: null,
  })

  async function GetProperty(id){
    try {
      const response = await dispatch(LoadProperty(id));
      const property = response.data.data;
      setData({
        Name: property.name,
        Unit: property.unit,
        selectedImage: property.image ? property.image : null,
        image_api:  property.image ? property.image : null,
        Note: property.note,
      });
    } catch (error) {
      
    }
  }

  useEffect(() => {
    GetProperty(id);
  }, []);
  // const property = response.data.data
  //id = property id 


  const [statepage, setStatepage] = useState('');
  const handleSelectPage = (e) => setStatepage(e);
  const [key, setKey] = useState('Data');
  // console.log(statepage);
  function closePackage() {
    let path = `/property`;
    history.push(path);
  }

  return (
    <>
      <NavbarTop />
      <Container
        fluid
        className="package-container Staff   Property Property-data bg-mrk"
      >
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={PropertyImage} />
                  <b><Link to="/property" className='link-pagination'>รายการทรัพย์สิน</Link> &gt; {DataProperty.Name}</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePackage}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePackage}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={PropertyImage} />
                  <b><Link to="/property" className='link-pagination'>รายการทรัพย์สิน</Link> &gt; {DataProperty.Name}</b>
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>

                <Row className="g-0 justify-content-center Staff-tabs">
                  <Col className="justify-content-start  ">
                    <div className="box-typecar ">
                      <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-4"
                      >
                        <Tab eventKey="Data" title="ข้อมูลทรัพย์สิน">
                          <Row className="Data-height justify-content-center">
                            <Data isEdit={true} id={id}/>
                          </Row>
                        </Tab>
                        {
                          <Tab eventKey="Storage " title="รายการจัดเก็บ">
                            <Row className="justify-content-center">
                              <Storage id={id} />
                            </Row>
                          </Tab>
                        }
                      </Tabs>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
